import { Component, Input } from '@angular/core';
import { ModalConfig } from '@df/ui/modal/modal-config';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { TranslationModule } from '@df/ui/translation/translation.module';

export namespace NModalLayoutRight {
    export const ModalConfig: ModalConfig = {
        closeOnNavigation: true,
        height: '100vh',
        transformOptions: 'translate3d(100%, 0px, 0px)',
        position: {
            top: '0',
            bottom: '0',
            right: '0'
        },
        transitionOptions: '500ms ease-in-out',
        hasBackdrop: true
    };
}

@Component({
    selector: 'modal-layout-right',
    templateUrl: 'modal-layout-right.html',
    standalone: true,
    imports: [TranslationModule],
    styleUrls: ['./modal-layout-right.scss']
})
export class ModalLayoutRightComponent {
    /**
     * Dependencies
     */
    constructor(private modalRef: ModalRef<any>) {}
    /**
     * Close modal
     */
    close() {
        this.modalRef.close();
    }

    @Input()
    titleShadow = true;

    @Input()
    lockScrollSpace = false;
}
